import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "./store";
import Cookies from "js-cookie";

const initialState = {
  loggedInUser: null,
  authenticated: false,
  tokenData: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.loggedInUser = action.payload;
    },
    setAuthenticated: (state, action) => {
      state.authenticated = action.payload;
    },
    setTokenData: (state, action) => {
      state.tokenData = action.payload;
    },
  },
});

export const logInUser = (loginData: any) => {
  return async (dispatch: any, getState: any) => {
    const { loggedInUser, authenticated, token } = loginData;
    dispatch(setUser(loggedInUser));
    dispatch(setAuthenticated(authenticated));
    const { tokenExpiryDate } = loggedInUser;
    dispatch(
      setTokenData({
        token,
        tokenExpiryDate,
      })
    );
    Cookies.set("token", token, {});
    Cookies.set("tokenExpiryDate", tokenExpiryDate, {});
  };
};

export const logTempToken = (tokenData: any) => {
  return async (dispatch: any, getState: any) => {
    const { tokenExpiryDate, token } = tokenData;
    dispatch(setUser(null));
    dispatch(setAuthenticated(false));
    dispatch(
      setTokenData({
        token,
        tokenExpiryDate,
      })
    );
    Cookies.set("token", token, {});
    Cookies.set("tokenExpiryDate", tokenExpiryDate, {});
  };
};

export const logOutUser = () => {
  return async (dispatch: any, getState: any) => {
    dispatch(setUser(null));
    dispatch(setAuthenticated(false));
    dispatch(setTokenData(null));
    Cookies.remove("token");
    Cookies.remove("tokenExpiryDate");
  };
};

export const getActiveUser = (state: RootState, loggedInUser: any = null) => {
  const fallbackTokenData = {
    token: loggedInUser?.token || null,
    tokenExpiryDate: loggedInUser?.tokenExpiryDate || null,
  };
  return {
    loggedInUser: state.auth.loggedInUser || loggedInUser || null,
    authenticated: !!(state.auth.authenticated || loggedInUser?.token),
    tokenData: state.auth.tokenData || fallbackTokenData,
  };
};

export const { setUser, setAuthenticated, setTokenData } = authSlice.actions;
export default authSlice.reducer;
